import { w as withConfigTransport } from "../../services/config-transport/withConfigTransport-2705a6a5.mjs";
import { _ as _sfc_main } from "./VaBreadcrumbs.vue_vue_type_script_lang-35f26adc.mjs";
import { _ as _VaBreadcrumbsItem } from "./VaBreadcrumbsItem/VaBreadcrumbsItem-24004a99.mjs";
const VaBreadcrumbsItem = withConfigTransport(_VaBreadcrumbsItem);
const VaBreadcrumbs = withConfigTransport(_sfc_main);
export {
  VaBreadcrumbsItem as V,
  VaBreadcrumbs as a
};
//# sourceMappingURL=index-696950bd.mjs.map
